import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ModalTab } from "./ArtistPreviewModal";
interface ArtistPreviewModalTabsProps {
  readonly activeTab: ModalTab;
  readonly onTabChange: (tab: ModalTab) => void;
}
export const ArtistPreviewModalTabs: React.FC<ArtistPreviewModalTabsProps> = t0 => {
  const $ = _c(13);
  const {
    activeTab,
    onTabChange
  } = t0;
  let t1;
  if ($[0] !== onTabChange) {
    t1 = () => onTabChange("active");
    $[0] = onTabChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `tw-flex-1 tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-transition tw-duration-300 ${activeTab === "active" ? "tw-bg-iron-800 tw-font-medium tw-text-iron-50 tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.06),inset_0_0_6px_rgba(0,0,0,0.15)]" : "tw-bg-transparent tw-text-iron-400 desktop-hover:hover:tw-text-iron-300"}`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <button onClick={t1} className={t2}>Active Submissions</button>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onTabChange) {
    t4 = () => onTabChange("winners");
    $[5] = onTabChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `tw-flex-1 tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-transition-all tw-duration-300 ${activeTab === "winners" ? "tw-bg-[#3F3A31] tw-font-medium tw-text-[#EADFBF] tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.06),inset_0_0_6px_rgba(0,0,0,0.2)]" : "tw-bg-transparent tw-text-iron-400 desktop-hover:hover:tw-text-iron-300"}`;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <button onClick={t4} className={t5}>Minted to Memes</button>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="tw-relative tw-mt-4 tw-inline-flex tw-w-full tw-px-6 sm:tw-w-auto"><div className="tw-flex tw-h-9 tw-w-full tw-items-center tw-overflow-hidden tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-px-1 tw-text-xs tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] sm:tw-w-auto">{t3}{t6}</div></div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};